import React, { useMemo } from 'react';
import { RCPWithQueryParams } from 'util/routing';
import { Filter, Model } from 'util/backendapi/models/api.interfaces';
import {
  observationPointTimeDependentFieldListFilters,
  observationPointTimeDependentFieldListColumns,
  ObservationPointTimeDependentFieldListView,
} from './ObservationPointTimeDependentFieldListView';
import { useReportState } from 'hooks/use-report-state';
import { maintenanceRequiredListDuck } from 'ducks/maintenance-required/list';
import { ReportViewProps } from 'components/modules/report/report-types';
import { t, Trans } from '@lingui/macro';

type OwnProps =
  RCPWithQueryParams<Filter.ObservationPointTimeDependentFieldFilters>;

export function MaintenanceRequiredListView(props: {
  reportProps: ReportViewProps<Model.ReportsObservationPointTimeDependentField>;
  valueOptions: Record<string, string>;
}) {
  const { reportProps, valueOptions } = props;

  return (
    <ObservationPointTimeDependentFieldListView
      reportProps={reportProps}
      header={<Trans>Maintenance required report</Trans>}
      reportUrl="/reports/maintenance-required/"
      fileNameBase={t`Maintenance required`}
      valueOptions={valueOptions}
    />
  );
}

export const MaintenanceRequiredListScreen = (ownProps: OwnProps) => {
  const columns = useMemo(() => {
    return observationPointTimeDependentFieldListColumns();
  }, []);

  const valueOptions = {
    true: 'Yes',
    false: 'No',
  };

  const props = {
    reportProps: useReportState(
      ownProps,
      columns,
      observationPointTimeDependentFieldListFilters,
      maintenanceRequiredListDuck,
      (state) => state.maintenanceRequired.list
    ),
  };

  return <MaintenanceRequiredListView {...props} valueOptions={valueOptions} />;
};
